<template>
    <nav>
        <slot v-bind:toggleNav="toggleNav"></slot>
    </nav>
</template>

<script>
    export default {
        name: "Navbar",

        props: ['targetId'],

        methods: {
            toggleNav() {
                document.getElementById(this.targetId).classList.toggle('hidden');
                document.getElementById(this.targetId).classList.toggle('opacity-0');
            }
        }
    }
</script>

<style scoped>

</style>